/**
 * Valuation Result Component
 * 
 * Handles the valuation result display and functionality.
 */

/**
 * Initialize valuation result functionality
 * @param {Object} widget The widget instance
 */
export function initializeValuationResult(widget) {
    // Set up valuation result display
    setupValuationResultDisplay(widget);
    
    // Set up download report button
    // setupDownloadReportButton();
    setReportUrl();
  }
  
  /**
   * Set up valuation result display
   * @param {Object} widget The widget instance
   */
  function setupValuationResultDisplay(widget) {
    // Update the valuation result when it becomes available
    document.addEventListener('widget-state-update', (event) => {
      if (event.detail && event.detail.valuationResult) {
        updateValuationDisplay(widget, event.detail.valuationResult);
      }
    });
  }
  
  /**
   * Update the valuation display with results
   * @param {Object} widget The widget instance
   * @param {Object} result The valuation result
   */
  function updateValuationDisplay(widget, result) {
    const valuationResult = document.querySelector('.valuation-result');
    const confidenceBarFill = document.querySelector('.confidence-bar-fill');
    const confidenceText = document.querySelector('.confidence-level span:last-child');
    
    if (valuationResult && result) {
      // Format currency based on language
      const formatter = new Intl.NumberFormat(
        widget.config.language === 'en' ? 'en-US' : 
        widget.config.language === 'fr' ? 'fr-CH' : 
        widget.config.language === 'de' ? 'de-CH' : 
        widget.config.language === 'it' ? 'it-CH' : 'en-US', 
        {
          style: 'currency',
          currency: 'CHF',
          maximumFractionDigits: 0
        }
      );
      
      // Update the DOM elements
      valuationResult.textContent = `${formatter.format(result.price_interval.lower)} - ${formatter.format(result.price_interval.upper)}`;
      
      if (confidenceBarFill && result.confidence) {
        // Set confidence level (1-3)
        const confidencePercent = result.confidence * 33; // 1=33%, 2=66%, 3=100%
        confidenceBarFill.style.width = `${confidencePercent}%`;
        
        // Update confidence text
        if (confidenceText) {
          confidenceText.textContent = widget.getText(
            result.confidence === 1 ? 'low' : 
            result.confidence === 2 ? 'medium' : 'high'
          );
        }
      }
    }
  }
  
  /**
   * Set up download report button
   */
  function setupDownloadReportButton() {
    const downloadButton = document.querySelector('.result-actions .action-button:first-child');
    
    if (downloadButton) {
      downloadButton.addEventListener('click', (event) => {
        // URL will be set when the result is available
        // If we don't have a URL yet, prevent the default action
        if (!downloadButton.getAttribute('data-report-url')) {
          event.preventDefault();
          alert('Report is not yet available. Please try again in a few moments.');
        }
      });
    }
  }
  
  /**
   * Set report URL on the download button
   * @param {string} url The report URL
   */
  export function setReportUrl(url) {
    const downloadButton = document.querySelector('.result-actions .action-button:first-child');
    
    if (downloadButton && url) {
      downloadButton.setAttribute('data-report-url', url);
      downloadButton.addEventListener('click', () => {
        window.open(url, '_blank');
      });
    }
  }